export const copyResume = (content: string, contentElement: HTMLElement) => {
  if (!contentElement) {
    return;
  }

  const applyInlineStyles = (element: HTMLElement) => {
    const computedStyle = window.getComputedStyle(element);
    const importantStyles = [
      'font-family',
      'font-size',
      'font-weight',
      'font-style',
      'text-align',
      'line-height',
      'margin',
      'padding',
      'color',
      'background-color',
      'text-decoration',
      'list-style-type',
      'display',
    ];

    importantStyles.forEach((style) => {
      const value = computedStyle.getPropertyValue(style);

      if (value) {
        element.style.setProperty(style, value, 'important');
      }
    });

    Array.from(element.children).forEach((child) => {
      if (child instanceof HTMLElement) {
        applyInlineStyles(child);
      }
    });
  };

  applyInlineStyles(contentElement);

  const htmlContent = `
          <html>
            <head>
              <style>
                body { font-family: Cambria, serif; }
                * { font-family: Cambria, serif !important; }
              </style>
            </head>
            <body>
              ${contentElement.innerHTML}
            </body>
          </html>
        `;

  const clipboardItem = new ClipboardItem({
    'text/html': new Blob([htmlContent], { type: 'text/html' }),
    'text/plain': new Blob([content], { type: 'text/plain' }),
  });

  navigator.clipboard.write([clipboardItem]);
};
